module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "article item",
    attrs: {
      "href": _vm.post.source,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.post.thumbnail.url,
      "alt": _vm.post.thumbnail.alt,
      "title": _vm.post.thumbnail.alt
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "article-body"
  }, [_c('h2', {
    staticClass: "article-title"
  }, [_vm._v("\n            " + _vm._s(_vm.post.title) + "\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "article-content",
    domProps: {
      "innerHTML": _vm._s(_vm.post.content)
    }
  }), _vm._v(" "), _c('footer', {
    staticClass: "article-info"
  }, [_c('span', [_vm._v(_vm._s(_vm.post.date))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.post.source_name))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-177ec99c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/news/news-external.vue
// module id = 166
// module chunks = 4